import { render, staticRenderFns } from "./StaffActionsTable.vue?vue&type=template&id=7cf75bc2&scoped=true"
import script from "./StaffActionsTable.vue?vue&type=script&lang=js"
export * from "./StaffActionsTable.vue?vue&type=script&lang=js"
import style0 from "./StaffActionsTable.vue?vue&type=style&index=0&id=7cf75bc2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf75bc2",
  null
  
)

export default component.exports